import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { UrlParamsService } from './url-params.service';
import {MetricsService} from '../../../shared/services/metrics.service';
import {isNestBank} from '../../utils/utils';
import {SessionStorage} from '../global/storage/session-storage.service';
import {QueryParamName} from '../../enums/query-param-name.enum';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {ApplicationStateService} from '../../../shared/services/application-state.service';

@Injectable({
  providedIn: 'root'
})
export class ParamsResolverGuard implements CanActivate {

  get contextIdAllowed(): boolean {
    return isNestBank();
  }

  queryParams: any;

  constructor(private urlParamsService: UrlParamsService,
              private metricsService: MetricsService,
              private sessionStorage: SessionStorage,
              private stateService: ApplicationStateService) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (isNotNullOrUndefined(route.queryParams) && isNotNullOrUndefined(route.queryParams.contextId)) {
      this.handleContextId(route.queryParams.contextId);
    }

    this.urlParamsService.saveQueryParams(route.queryParams);
    this.metricsService.updateContextWithUrlParams();
    return true;
  }

  private handleContextId(contextId: string): void {
    const previousContextId = this.urlParamsService.getQueryParam(QueryParamName.CONTEXT_ID);
    if (this.contextIdAllowed && isNotNullOrUndefined(previousContextId) && contextId !== previousContextId) {
      this.sessionStorage.clear();
      this.stateService.resetApplicationState();
    }
  }


}
